<template>
  <div>
    <user-detail-title
        first-bread="公司招聘"
        second-bread="公司招聘添加"
        first-url="/user/recruitment"
        title-name="公司招聘添加"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="招聘岗位" >
          <el-input v-model="Alist.post" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="薪资">
          <el-input v-model="Alist.salary" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="岗位职责">
          <el-input type="textarea" :rows="4" v-model="Alist.duty"></el-input>
        </el-form-item>
        <el-form-item label="岗位要求">
          <el-input type="textarea" :rows="4" v-model="Alist.demand"></el-input>
        </el-form-item>
        <el-form-item label="职位详情">
          <el-input type="textarea" :rows="4" v-model="Alist.postDetail"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" style="width: 400px">
          <el-input v-model="Alist.email" type="email"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" style="width: 300px">
          <el-input v-model="Alist.phoneNumber" type="tel"></el-input>
        </el-form-item>

      </el-form>
    </user-detail-base>
    <el-button @click="handleAdd()">添加</el-button>
  </div>
</template>

<script>
  import UserDetailTitle from "@/views/User/Common/UserDetailTitle";
  import UserDetailBase from "@/views/User/Common/UserDetailBase";
  export default {
    name: "RecruitmentAdd",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        Alist: {
          'post':null,
          'salary':null,
          'duty':null,
          'demand':null,
          'email':null,
          'phoneNumber':null,
          'postDetail': null
        },//表示Add添加的数据
      }
    },
    methods:{
      handleAdd(){
        this.$axios.post('/api/job/add',this.Alist).then(res=>{
          if(res.data.success == true){
            this.$message({
              message:'添加成功',
              type:'success'
            })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>